'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
Polymer({
  is: 'moskito-song-details',
  _template: html`
<style>
:host {
  display: block;
  margin: 20px 30px;
}
.msd_authors {
  @apply --layout-horizontal;
  @apply --layout-wrap;
  width: 100%;
}
paper-card {
  --paper-card-background-color: var(--paper-blue-grey-500);
  color: var(--paper-blue-grey-100);
  max-width: 100px;
  margin-bottom: 12px;
  background-color: var(--paper-blue-grey-500);
}
paper-card div a {
  text-decoration: none;
  color: var(--paper-blue-grey-100);
}
.msd_authors paper-card {
  --paper-card-background-color: var(--paper-blue-grey-500);
  color: var(--paper-blue-grey-100);
  max-width: 100px;
  margin-bottom: 12px;
}
.msd_authors paper-card div a {
  text-decoration: none;
  color: var(--paper-blue-grey-100);
}
h3 {
  margin-top: 12px;
}
</style>
<div class="layout vertical">
  <h3>Titre</h3>
  <div class="layout horizontal alinea">
    <div class="layout vertical flex">
      <h4 class="margin-before-0">Original</h4>
      <div>{{data.title.original.main}}</div>
    </div>
    <div class="layout vertical flex">
      <h4 class="margin-before-0">Langue Originale</h4>
      <div>{{data.title.original.language}}</div>
    </div>
    <div class="layout vertical flex">
      <h4 class="margin-before-0">Sous-Titre Original</h4>
      <div>{{data.title.original.subtitle}}</div>
    </div>
  </div>
  <dom-if if={{isTranslation(data.title)}}>
  <template is="dom-if">
    <div class="layout horizontal alinea">
      <div class="layout vertical flex">
        <h4 class="margin-before-0">Traduction</h4>
        <div>{{data.title.translation.main}}</div>
      </div>
      <div class="layout vertical flex">
        <h4 class="margin-before-0">Langue de Traduction</h4>
        <div>{{data.title.translation.language}}</div>
      </div>
      <div class="layout vertical flex">
        <h4 class="margin-before-0">Sous-Titre Traduction</h4>
        <div>{{data.title.translation.subtitle}}</div>
      </div>
    </div>
  </template>
</dom-if>
  
<h3>Auteur(s)</h3>
<div>
  <moskito-authors authors=[[authors]]></moskito-authors>
</div>

<h3>Droits et Copyright</h3>
<iron-collapse id="copyrightContent">
  <div class="layout vertical alinea">Hop
    <moskito-publishing-tree data="{{data.rights}}" editable="false"></moskito-publishing-tree>
  </div>
</div>
  `,
  properties: {
    data: {
      type: Array,
      notify: true
    },
    extra: {
      type: Array,
      notify: true
    },
    authors: {
      type: Array,
      computed: 'getAuthors(extra)'
    }

  },
  isTranslation: function (title) {
    if (title.original.language === 'fr') {
      return false
    } else {
      return true
    }
  },
  toggleIcon: function (e) {
    if (e.target.children[0].icon === 'icons:expand-less') {
      e.target.children[0].icon = 'icons:expand-more'
    } else {
      e.target.children[0].icon = 'icons:expand-less'
    }
  },
  toggleTitle: function (e) {
    this.$.titleContent.toggle()
    this.toggleIcon(e)
  },
  toggleAuthor: function (e) {
    this.$.authorContent.toggle()
    this.toggleIcon(e)
  },
  toggleCopyright: function (e) {
    this.$.copyrightContent.toggle()
    this.toggleIcon(e)
  },
  getAuthors: function (extra) {
    return extra.filter(item => item['type'] === 'authors')
  }
})
